import { FlexBox, SPACING, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { useShallow } from "zustand/react/shallow"

import { useCatchUpStore } from "./useCatchUpStore"

const CatchUpCardEmptyState = () => {
  const { selectedChild } = useCatchUpStore(
    useShallow((state) => ({
      selectedChild: state.selectedChild,
    }))
  )
  const { t } = useTranslation()
  return (
    <FlexBox
      direction="column"
      justify="space-between"
      align="center"
      style={{
        height: "min(600px, calc(100vh - 80px))",
        padding: `${SPACING.space14} ${SPACING.space6} ${SPACING.space6}`,
      }}
    >
      <div className="flex flex-col items-center gap-2">
        <img
          src="/images/party_popper.gif"
          alt="party-popper"
          className="w-16 h-16 mb-4"
        />
        <Typography variant="bodyBold" textAlign="center">
          {t("CATCHUP_APPROVED_ALL", { name: selectedChild?.user.name })}
        </Typography>
        <Typography variant="bodySmall" textAlign="center">
          {t("CATCHUP_EARNED_COINS")}
        </Typography>
        <img
          src="/images/redeem_from_mailman.png"
          alt="redeem-from-mailman"
          className="w-full"
        />
      </div>
    </FlexBox>
  )
}

export default CatchUpCardEmptyState
